export function getPdfName(consent) {
    return `${consent.status === 'Completed' ? 'Signed-' : 'Unsigned-'}${consent.patient.first_name}-${consent.patient.last_name}-${consent.id}-consent-form.pdf`;
}